import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessengerService } from '../services/messenger-service';
import { DashboardService } from '../../../services/dashboard.service'

@Component({
  selector: 'app-chat-user-list',
  templateUrl: './chat-user-list.component.html',
  styleUrls: ['./chat-user-list.component.scss']
})
export class ChatUserListComponent implements OnInit {
  
  searchUsers:any;
  userList:any;
  allUsers:any = [];
  reqSubcription: Subscription[] = [];
  @Output('selectedUser') selectedUser = new EventEmitter<any>();

  constructor(
     private dashboardService: DashboardService,
  ) {

   }
  
   loadAllUserData() {  
    this.reqSubcription.push(this.dashboardService.getAllUser().subscribe((res:any) => {
      this.userList = res ? res : [];
    }))
  }
   
    
  ngOnInit(): void {
    this.loadAllUserData();
  }

  userSelection(data:any) {
    this.selectedUser.emit(data);
    this.searchUsers = '';
  }

 filteredContacts() {
  if (!this.searchUsers) return this.userList;
  return this.userList.filter((contact: any) =>
    contact.usr_display_nm?.toLowerCase().includes(this.searchUsers.toLowerCase())
  );
}

}
